export const environment = {
  name:"deploy",
  production: true,
  apiUrl:"/_vti_bin/webapi/CustomersAuthentication/PostAuthenticate/",
  apiElasticLogUrl:'',
  prefixUrl:"/SiteAssets/assets/harel-customers/assets"
};
